export interface TouchState {
  id: number;
  x: number;
  y: number;
}

export class MultiTouchTracker {
  touches = new Map<number, TouchState>();

  down(id: number, x: number, y: number) {
    this.touches.set(id, { id, x, y });
  }
  move(id: number, x: number, y: number) {
    const t = this.touches.get(id);
    if (t) {
      t.x = x;
      t.y = y;
    }
  }
  up(id: number) {
    this.touches.delete(id);
  }
  clear() {
    this.touches.clear();
  }
  count() {
    return this.touches.size;
  }

  centroid(): { x: number; y: number } | null {
    if (this.touches.size === 0) return null;
    let sx = 0, sy = 0;
    for (const t of this.touches.values()) {
      sx += t.x;
      sy += t.y;
    }
    return { x: sx / this.touches.size, y: sy / this.touches.size };
  }

  spread(): number {
    if (this.touches.size < 2) return 0;
    const pts = [...this.touches.values()].slice(0, 2);
    const dx = pts[1]!.x - pts[0]!.x;
    const dy = pts[1]!.y - pts[0]!.y;
    return Math.hypot(dx, dy);
  }
}
